import React from "react";
import "../components-css/loader.scss";

const Loader = () => {
  return (
    <div className="loader-background">
      <div className="shimmer-banner">
        <div className="shimmer-content">
          <div className="shimmer-title"></div>
          <div className="shimmer-subtitle"></div>
          <div className="shimmer-button"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
